import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { AddEditExemptVendorTypeModalComponent } from 'src/app/modals/add-edit-exempt-vendor-type-modal/add-edit-exempt-vendor-type-modal.component';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-client-admin-compliance-exempt-setup',
  templateUrl: './client-admin-compliance-exempt-setup.component.html',
  styleUrls: ['./client-admin-compliance-exempt-setup.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientAdminComplianceExemptSetupComponent {
  constructor(
    private ModalService: NgbModal,
    private ToastService: ToastService,
    private CompanyService: CompanyService
  ) {}

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['edit', 'delete']
  };

  suppliedGridQueryData: { [key: string]: any } = {};
  reloadGrid: boolean = false;

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    const { id, type } = rowData;

    if (!id) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot perform action. Row data has no ID.',
        { returnError: true }
      );
    }

    if (action === 'edit') {
      const modalRef = this.ModalService.open(
        AddEditExemptVendorTypeModalComponent,
        { centered: true, size: 'lg' }
      );
      modalRef.componentInstance.ExemptVendorTypeId = id;

      modalRef.closed.subscribe({
        next: () => {
          this.reloadGrid = true;
        }
      });
    }

    if (action === 'delete') {
      const modalRef = this.ModalService.open(ConfirmModalComponent, {
        centered: true,
        size: 'lg'
      });
      modalRef.componentInstance.displayText = `Are you sure you want to delete exempt vendor type: ${type}`;

      modalRef.closed.subscribe({
        next: (result) => {
          if (result) {
            this.CompanyService.deleteCompanyExemptVendorType(id).subscribe({
              next: () => {
                this.ToastService.addSuccessToast(
                  'Success',
                  'Successfully deleted ExemptVendorType.'
                );
                this.reloadGrid = true;
              }
            });
          }
        }
      });
    }
  }

  addExemptType() {
    const modalRef = this.ModalService.open(
      AddEditExemptVendorTypeModalComponent,
      { centered: true, size: 'lg' }
    );

    modalRef.closed.subscribe({
      next: () => {
        this.reloadGrid = true;
      }
    });
  }
}
